export default __webpack_public_path__ + "static/media/payment-g-pay.3225baff.svg";